/**
 * The table with every entry rebuilt by `shape` (content/shapes.ts: one literal, one hidden class for all of
 * them), replaced in place so the table itself stays the fast literal it was. A field the shape doesn't know
 * would be lost, so that stops the load instead.
 */
export const uniform = <D extends object, T extends Record<string, D>>(table: T, shape: (d: D) => D): T => {
  for (const [kind, def] of Object.entries(table)) {
    const o = shape(def);
    for (const k of Object.keys(def)) if (!(k in o)) throw new Error(`uniform: ${kind}.${k} is missing from its shape (content/shapes.ts)`);
    (table as Record<string, D>)[kind] = o;
  }
  return table;
};
